<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-width="220px"
    class="demo-ruleForm"
  >
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="商家基本信息" name="first">
        <el-form-item label="商家id">
          <el-input v-model="form.supply_id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="商家名称">
          <el-input v-model="form.supply_name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="是否可刷单" prop="is_scal">
          <el-select v-model="form.is_scal" :disabled="true">
            <el-option
              v-for="item in is_scal_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家状态" prop="supply_status">
          <el-select v-model="form.supply_status" :disabled="true">
            <el-option
              v-for="item in supply_status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易方式" prop="settle_type">
          <div style="display: flex; flex-direction: row">
            <div>
              <el-select
                v-model="form.settle_type"
                style="width: 200px"
                :disabled="true"
              >
                <el-option
                  v-for="item in settle_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <supply-select
              v-if="form.settle_type == 2"
              :data="{
                is_signed_contract: form.is_signed_contract,
                settle_days: form.settle_days,
              }"
              :disabled="true"
              @returnData="returnData"
            ></supply-select>
          </div>
        </el-form-item>

        <el-form-item label="城市" prop="city">
          <el-select v-model="form.city" filterable :disabled="true">
            <el-option
              v-for="item in citys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市场" prop="father_market">
          <el-select v-model="form.father_market" filterable :disabled="true">
            <el-option
              v-for="item in market"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子市场" prop="market_id">
          <el-select v-model="form.market_id" filterable :disabled="true">
            <el-option
              v-for="item in child_market"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层" prop="supply_floor">
          <el-select v-model="form.supply_floor" filterable :disabled="true">
            <el-option
              v-for="item in floor"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域/街" prop="supply_area_id">
          <el-select v-model="form.supply_area_id" filterable :disabled="true">
            <el-option
              v-for="item in supply_area_list"
              :key="item.supply_area_id"
              :label="item.supply_area"
              :value="item.supply_area_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口号" prop="supplier_num">
          <el-autocomplete
            v-model="form.supplier_num"
            class="inline-input"
            :disabled="true"
          ></el-autocomplete>
          <!--<el-input v-model="form.supply_name"></el-input>-->
        </el-form-item>
        <el-form-item label="商家地址">
          <el-input v-model="form.supply_address" disabled></el-input>
        </el-form-item>
        <el-form-item label="一手商城档口名">
          <el-input v-model="form.supply_nickname" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input
            v-model="form.brand"
            :disabled="true"
            style="width: 50%; float: left"
          ></el-input>
        </el-form-item>

        <el-form-item label="代采组" prop="pgid">
          <el-select v-model="form.pgid" filterable :disabled="true">
            <el-option
              v-for="item in pg_list"
              :key="item.pgid"
              :label="item.pgname"
              :value="item.pgid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代采员" prop="pg_member_id">
          <el-select v-model="form.pg_member_id" :disabled="true">
            <el-option key="0" value="0" label="全部"></el-option>
            <el-option
              v-for="item in memberOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="次品组" prop="dgid">
          <el-select v-model="form.dgid" :disabled="true">
            <el-option key="0" value="0" label="请选择"></el-option>
            <el-option
              v-for="item in defectiveGroupOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="次品员" prop="dg_member_id">
          <el-select v-model="form.dg_member_id" :disabled="true">
            <el-option key="0" value="0" label="请选择"></el-option>
            <el-option
              v-for="item in defectiveGroupMemberOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="买手组" prop="pg_id">
          <el-select v-model="form.pg_id" filterable :disabled="true">
            <el-option key="0" value="0" label="无"></el-option>
            <el-option
              v-for="item in pickers"
              :key="item.pg_id"
              :label="item.pg_name"
              :value="item.pg_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="买手" prop="supply_picker_group_member_id">
          <el-select
            v-model="form.supply_picker_group_member_id"
            filterable
            :disabled="true"
          >
            <el-option key="0" value="0" label="无"></el-option>
            <el-option
              v-for="item in PickerGroupMemberOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商家运营跟进人" prop="follower">
          <el-select
            v-model="form.follower_admin_id"
            filterable
            :disabled="true"
          >
            <el-option key="0" value="0" label="请选择"></el-option>
            <el-option
              v-for="item in (resData || {}).follower"
              :key="item.value"
              :disabled="item.admin_status == 0"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商家开发人" prop="supply_developer">
          <el-select
            v-model="form.supply_developer_admin"
            filterable
            :disabled="true"
          >
            <el-option
              v-for="item in supply_developer"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input
            v-model="form.supply_mobile_phone"
            :disabled="true"
          ></el-input>
          <el-input v-model="form.supply_wechat" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="商品默认活跃值" prop="supply_action_value">
          <el-input
            v-model="form.supply_action_value"
            style="width: 45%"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="排单锁定天数" prop="limit_day">
          <el-input v-model="form.limit_day" type="number" :disabled="true">
            <template #append>天</template>
          </el-input>
        </el-form-item>

        <el-form-item
          v-for="(payee, index) in form.payees"
          :key="payee.key"
          :label="'收款人信息' + (index + 1)"
          :prop="'payee.' + index + '.value'"
          prop=""
        >
          <el-input
            disabled
            :value="
              payee.payee_name +
              '-' +
              payee.payee_bank +
              '-' +
              payee.cnap_name +
              '-' +
              payee.payee_bank_account
            "
            style="width: 70%"
            :disabled="true"
          ></el-input>
          <el-radio v-model="form.is_default" :label="index" :disabled="true"
            >默认收款账号
          </el-radio>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </el-tab-pane>
      <el-tab-pane label="商家权限" name="second"
        >商家权限
        <el-form-item label="是否KA" prop="is_ka">
          <el-select v-model="form.is_ka" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否实力档口" prop="is_strength">
          <el-select v-model="form.is_strength" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后提前代采计划" prop="as_plan">
          <el-select v-model="form.as_plan" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="重新代采计划全量生成" prop="all_rebuild_plan">
          <el-select v-model="form.all_rebuild_plan" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退换货是否需接收" prop="reject_accept">
          <el-select v-model="form.reject_accept" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否全款全上" prop="is_strength">
          <el-select v-model="form.is_full" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否自主上款" prop="is_self">
          <!-- 开通邀约的,此项置灰 -->
          <el-select v-model="form.is_self" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式" prop="is_self">
          <!-- 设置分账就置灰 -->
          <el-select v-model="form.pay_method" :disabled="true">
            <el-option
              v-for="item in options.pay_methods"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span v-if="form.effective_time" style="color: red"
            >生效时间 {{ form.effective_time }}</span
          >
        </el-form-item>
        <el-form-item label="是否轻入驻" prop="is_lower_enter">
          <el-select v-model="form.is_lower_enter" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="form.is_lower_enter == 1"
          label="月目标"
          prop="m_goal"
        >
          <el-input
            v-model="form.m_goal"
            type="number"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否开启直播" prop="is_live">
          <el-select v-model="form.is_live" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="是否开启截图上款"
          prop="is_screenshot_for_add_goods"
        >
          <el-select
            v-model="form.is_screenshot_for_add_goods"
            :disabled="true"
          >
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="form.is_live == 1"
          label="直播频率"
          prop="live_type"
        >
          <el-radio v-model="form.live_type" label="1" :disabled="true"
            >按次申请</el-radio
          >
          <el-radio v-model="form.live_type" label="2" :disabled="true"
            >不限直播次数</el-radio
          >
          <el-radio v-model="form.live_type" label="3" :disabled="true"
            >每周可自主直播
            <el-input
              v-if="form.live_type == 3"
              v-model="form.live_num"
              type="text"
              style="width: 100px"
              :value="form.live_num"
              :disabled="true"
            ></el-input>
            次
          </el-radio>
          <el-radio v-model="form.live_type" label="4" :disabled="true"
            >每月可自主直播
            <el-input
              v-if="form.live_type == 4"
              v-model="form.live_num"
              type="text"
              style="width: 100px"
              :value="form.live_num"
              :disabled="true"
            ></el-input>
            次
          </el-radio>
        </el-form-item>
        <el-form-item label="履约率标杆商家" prop="is_benchmarking">
          <el-select v-model="form.is_benchmarking" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自主上款是否需要审核" prop="is_self_need_audit">
          <el-select v-model="form.is_self_need_audit" :disabled="true">
            <el-option
              v-for="item in is_self_need_audit"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否邀请商家自主申请入驻" prop="open_deposit">
          <el-select v-model="form.open_deposit" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-tab-pane>
      <el-tab-pane label="商家标签" name="third">
        <el-form-item label="擅长季节" prop="season">
          <el-checkbox-group
            v-model="form.season"
            lable="擅长季节"
            :disabled="true"
          >
            <el-checkbox label="春季"></el-checkbox>
            <el-checkbox label="夏季"></el-checkbox>
            <el-checkbox label="秋季"></el-checkbox>
            <el-checkbox label="冬季"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="适合年龄阶段" prop="season">
          <el-checkbox-group v-model="form.age_group">
            <el-checkbox
              v-for="age in age_group_list"
              :key="age.key"
              :label="age.key"
              :disabled="true"
              >{{ age.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="档次" prop="supply_grade">
          <el-checkbox-group v-model="form.supply_grade" lable="档次">
            <el-checkbox label="低端" :disabled="true"></el-checkbox>
            <el-checkbox label="中低" :disabled="true"></el-checkbox>
            <el-checkbox label="中端" :disabled="true"></el-checkbox>
            <el-checkbox label="中高" :disabled="true"></el-checkbox>
            <el-checkbox label="高端" :disabled="true"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="擅长品类">
          <el-cascader
            v-model="form.cat_ids"
            :options="category"
            :props="{ multiple: true }"
            filterable
            :disabled="true"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item label="主要风格">
          <el-transfer
            v-model="form.styles"
            filterable
            :titles="['选项', '选中']"
            :data="styles_data"
            :disabled="true"
          >
          </el-transfer>
        </el-form-item>
        <el-form-item label="副风格">
          <el-transfer
            v-model="form.second_styles"
            filterable
            :titles="['选项', '选中']"
            :data="second_styles_data"
            :disabled="true"
            @change="build_styles"
          >
          </el-transfer>
        </el-form-item>

        <el-form-item label="一手店铺底图">
          <el-col :span="24" :style="'width:100%;'">
            <template>
              <div
                v-for="(item, index) in images1"
                v-if="images1"
                :key="index"
                style="
                  float: left;
                  width: 50px;
                  height: 50px;
                  margin: 0 10px;
                  border: 1px solid #ddd;
                "
              >
                <div style="position: relative">
                  <img
                    style="width: 50px; height: 50px"
                    :src="item"
                    @click="previewImage(item)"
                  />
                </div>
              </div>
            </template>
          </el-col>
        </el-form-item>
        <el-form-item label="档口实拍图">
          <el-col :span="24" style="width: 100%">
            <template>
              <div
                v-for="(item, index) in images4"
                v-if="images4"
                :key="index"
                style="
                  float: left;
                  width: 50px;
                  height: 50px;
                  margin: 0 10px;
                  border: 1px solid #ddd;
                "
              >
                <div style="position: relative">
                  <img
                    style="width: 50px; height: 50px"
                    :src="item"
                    @click="previewImage(item)"
                  />
                </div>
              </div>
            </template>
          </el-col>
        </el-form-item>
        <el-form-item label="品牌logo">
          <el-col :span="24" :style="'width:100%;'">
            <template>
              <div
                v-for="(item, index) in images3"
                v-if="images3"
                :key="index"
                style="
                  float: left;
                  width: 50px;
                  height: 50px;
                  margin: 0 10px;
                  border: 1px solid #ddd;
                "
              >
                <div style="position: relative">
                  <img
                    style="width: 50px; height: 50px"
                    :src="item"
                    @click="previewImage(item)"
                  />
                </div>
              </div>
            </template>
          </el-col>
        </el-form-item>

        <el-form-item label="营业执照">
          <el-col :span="24" :style="'width:100%;'">
            <template>
              <div
                v-for="(item, index) in images2"
                v-if="images2"
                :key="index"
                style="
                  float: left;
                  width: 50px;
                  height: 50px;
                  margin: 0 10px;
                  border: 1px solid #ddd;
                "
              >
                <div style="position: relative">
                  <img
                    style="width: 50px; height: 50px"
                    :src="item"
                    @click="previewImage(item)"
                  />
                </div>
              </div>
            </template>
          </el-col>
        </el-form-item>
        <el-form-item label="视频">
          <video
            v-if="form.supply_video"
            :src="form.supply_video"
            style="max-width: 80px; max-height: 80px"
            preload="metadata"
            @click="handleViewVideo(form.supply_video)"
          />
        </el-form-item>
        <el-form-item label="推荐描述">
          <el-input
            v-model="form.recommend_desc"
            style="width: 40%; float: left"
            maxlength="100"
            :disabled="true"
          ></el-input>
          <span style="color: red"
            >一手APP上的商家推荐描述（建议30字以内，否则在手机上超出的部分可能会变为省略号）</span
          >
        </el-form-item>
        <el-form-item label="品牌介绍">
          <el-input v-model="form.pg_say" :disabled="true"></el-input>
        </el-form-item>
      </el-tab-pane>

      <el-tab-pane label="爆版权限" name="fourth">
        <el-form-item label="爆版手机账号">
          <el-input
            v-model="form.baobmobile"
            style="width: 30%"
            :disabled="true"
          >
          </el-input>
          <span>（数据同步时间：{{ data_date }}）</span>
        </el-form-item>
        <el-form-item label="爆版店铺" prop="shopId">
          <el-select v-model="form.shopId" :disabled="true">
            <el-option
              v-for="item in shop_list"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否自主上款" prop="is_self">
          <!-- 开通邀约的,此项置灰 -->
          <el-select v-model="form.is_self" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自主设置一手独家款" prop="self_set_sole">
          <el-select v-model="form.self_set_sole" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自主上款全类目" prop="is_all_style">
          <!-- 开通邀约的,此项置灰 -->
          <el-select v-model="form.is_all_style" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开通爆版开单" prop="is_order_ability">
          <el-select v-model="form.is_order_ability" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开通库存共享" prop="baob_stock_sharing">
          <el-select v-model="form.baob_stock_sharing" :disabled="true">
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-tab-pane>
    </el-tabs>
  </el-form>
</template>

<script>
import Global_ from "../../components/Global.vue";
import { isSignedContractSupply, supplySettleDays } from "../../tool/const.js";
import SupplySelect from "./components/SupplySelect.vue";

export default {
  components: { SupplySelect },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
      if (!vm.resData) {
        vm.getSupplyPutLimit();
      }
    });
  },
  data() {
    return {
      initShopId: 0,
      addShopVisible: false,
      activeName: "first",
      bank: "",
      banks: [],
      cnaps: [],
      isSignedContractSupply: [],
      supplySettleDays: [],
      statusVisible: false,
      show_wx_add: false,
      temp_arr: [],
      wx_nickname_arr: [],
      brandVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      restaurants: [],
      timeout: null,
      floor_name: "",
      supply_area: "",
      brand_name: "",
      first_category: [],
      second_category: [],
      third_category: [],
      resData: null,
      supply: {
        list: [],
      },
      cats: [],
      pic: "",
      license: "",
      form: {
        is_signed_contract: "",
        settle_days: "",
        pg_member_id: "0",
        dg_member_id: "0",
        dgid: "0",
        is_show_brand: "1",
        is_main: 0,
        is_screenshot_for_add_goods: "0",
        supply_mobile_phone: "",
        supply_wechat: "",
        supply_action_value: 0,
        supply_name: "",
        limit_day: 7,
        supplier_num: "",
        // brand_id:0,
        pgid: 0,
        father_market: 0,
        market_id: 0,
        supply_floor: "",
        status: "",
        create_time: [],
        supply_id: this.$route.params.id,
        set_pgid: "", // 设置的代采组id
        is_scal: 1,
        is_strength: 0,
        reject_accept: 1,
        supply_status: 1,
        is_default: null,
        payees: [
          {
            payee_id: 0,
            payee_name: "",
            payee_bank: "",
            payee_bank_account: "",
          },
        ],
        brands: [
          {
            brand_id: 0,
            brand_name: "",
            status: 1,
          },
        ],
        season: [],
        supply_grade: [],
        age_group: [{}],
        pic: "",
        license: "",
        avatar: "",
        styles: [],
        second_styles: [],
        category: [],
        picture: [],
        cat: [],
        live_type: "",
        is_self: "",
        self_set_sole: "",
        is_all_style: "",
        is_self_need_audit: "",
        baobmobile: "",
        as_plan: "",
        supply_developer_admin: "",
        supply_picker_group_member_id: 0,
        is_benchmarking: "0",
        open_deposit: "0",
      },
      spayee: {
        payee_id: 0,
        payee_name: "",
        payee_bank: "",
        payee_bank_account: "",
        cnap: "",
      },
      images1: [],
      images2: [],
      images3: [],
      images4: [],
      styles_data: [],
      second_styles_data: [],
      advantage: "档口优点",
      disadvantage: "档口缺点",
      citys: [
        {
          value: "1",
          label: "广州",
        },
        {
          value: "2",
          label: "杭州",
        },
        {
          value: "3",
          label: "深圳",
        },
      ],
      supply_status: [
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      settle_type: [
        {
          value: "1",
          label: "常规代采",
        },
        {
          value: "2",
          label: "先货后款",
        },
      ],
      is_self_need_audit: [
        {
          value: "0",
          label: "不需要",
        },
        {
          value: "1",
          label: "需要",
        },
      ],
      // 这个反向options 0 是 1否 .. 小心小心小心小心小心小心小心
      is_scal_options: [
        {
          value: "0",
          label: "是",
        },
        {
          value: "1",
          label: "否",
        },
      ],
      public_option: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      shop_list: [
        {
          shopId: 0,
          shopName: "无",
        },
      ],
      options: [],
      market: [],
      child_market: [],
      floor: [],
      supply_area_list: [],
      pg_list: [],
      pickers: [],
      supply_developer: [],
      age_group_list: [],
      category: [],
      data_date: "",
      rules: {
        supplier_num: [
          {
            required: true,
            message: "请输入档口号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "档口号最长可以输入20个字符",
            trigger: "blur",
          },
        ],
        is_scal: [
          {
            required: true,
            message: "请选择是否可以刷单",
            trigger: "change",
          },
        ],
        supply_status: [
          {
            required: true,
            message: "请选择商家状态",
            trigger: "change",
          },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        father_market: [
          { required: true, message: "请选择市场", trigger: "change" },
        ],
        market_id: [
          {
            required: true,
            message: "请选择子市场",
            trigger: "change",
          },
        ],
        supply_floor: [
          { required: true, message: "请选择楼层", trigger: "change" },
        ],
        supply_area_id: [
          {
            required: true,
            message: "请选择区域/街",
            trigger: "change",
          },
        ],
        brand: [{ required: true, message: "请编辑品牌", trigger: "change" }],
        pgid: [
          {
            required: true,
            message: "请选择代采组",
            trigger: "change",
          },
        ],
        pg_member_id: [
          {
            required: true,
            message: "请选择代采员",
            trigger: "change",
          },
        ],
        dgid: [
          {
            required: true,
            message: "请选择次品组",
            trigger: "change",
          },
        ],
        dg_member_id: [
          {
            required: true,
            message: "请选择次品员",
            trigger: "change",
          },
        ],
        limit_day: [
          {
            required: true,
            message: "请输入排单锁定天数",
            trigger: "blur",
          },
        ],
      },
      baobmobile: null,
      loading: false,
      tableLoading: false,
      url: "/erp/Supply/showSupply",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
      files: [],
      memberOption: [],
      PickerGroupMemberOption: [],
      defectiveGroupMemberOption: [],
      defectiveGroupOption: [],
      savePayeeVisible: false,
      // 商家分层的tag
      setag: {
        show: false,
        form: {
          none_limit: "2", // 是否不限制
          limit_num: "",
        },
      },

      current_developer: "",
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.$http
      .get("/erp/Supply/getAllSupplierNum", this.filteredForm)
      .then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.restaurants = res.data.data;
        }
      });
  },
  methods: {
    AddShop() {
      this.$http
        .post("/erp/Supply/addBaobShop", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            // 修改后重新获取数据
            this.getShopList();
            this.addShopVisible = false;
            this.form.shopName = "";
            this.form.shopAddress = "";
            this.form.shopPhone = "";
            // this.fetchData(true);
          }
        });
    },
    getShopList() {
      this.loading = true;
      this.$http
        .post("/erp/supply/getBaobShopList", {
          baobmobile: this.form.baobmobile,
          supply_id: this.form.supply_id,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            if (res.data.code === 402) {
              const str =
                `当前此商家有${res.data.data.num}个相同的款号，共${res.data.data.kh_num}款商品。\n` +
                `若点击“立刻处理”，将会自动对以上商品修改款号\n` +
                `修改逻辑：从创建时间最早的同款商品开始添加前缀YS1-、YS2-...最新一个被创建的同款商品不会被添加前缀；\n` +
                `确定处理？`;
              this.$confirm(str, "相同款号商品", {
                confirmButtonText: "立刻处理",
                cancelButtonText: "取消",
                showClose: false,
                // type: 'warning'
              })
                .then(() => {
                  this.loading = true;
                  this.$http
                    .post("/erp/supply/autoUpdateKh", {
                      supply_id: this.form.supply_id,
                    })
                    .then((res) => {
                      this.loading = false;
                      if (res.data.code !== 200) {
                        this.$message.error(res.data.msg);
                      }
                      this.$message.success(res.data.msg);
                    });
                })
                .catch(() => {
                  return false;
                });
            } else {
              this.$message.error(res.data.msg);
            }
          } else {
            this.$message.success("获取成功");
            this.shop_list = res.data.data.shop_list;
          }
        });
    },
    unBindingBaob() {
      this.$confirm(
        "取消绑定后账号及关联店铺将被解绑，数据不会同步，店铺一手相关功能入口关闭！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        }
      )
        .then(() => {
          this.$http
            .post("/erp/supply/unBindingBaob", {
              supply_id: this.form.supply_id,
              shopId: this.form.shopId,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              }
            });
          this.fetchData(true);
        })
        .catch(() => {
          return false;
        });
    },
    getMemberOption(e) {
      if (!e) {
        return false;
      }
      this.memberOption = [];
      this.form.pg_member_id = "0";
      this.loading = true;
      this.$http.post("/erp/Common/getPgMember", { pgid: e }).then((res) => {
        this.loading = false;
        if (res.data.data.length < 1) {
          return this.$message.info("请先绑定代采员至该代采组下");
        }
        this.memberOption = res.data.data;
      });
    },
    getPickerGroupMemberOption(e) {
      if (!e) {
        return false;
      }
      this.PickerGroupMemberOption = [];
      this.form.supply_picker_group_member_id = "0";
      this.loading = true;
      this.$http
        .post("/erp/Common/getPickerGroupMember", { pg_id: e })
        .then((res) => {
          this.loading = false;
          if (res.data.data.length < 1) {
            return this.$message.info("请先绑定买手到该买手组下");
          }
          this.PickerGroupMemberOption = res.data.data;
        });
    },
    getDefectiveGroupMember(val) {
      if (!val) {
        return false;
      }
      this.form.dg_member_id = "0";
      this.defectiveGroupMemberOption = [];
      this.$http
        .post("/erp/Defective/getGroupMember", {
          dgid: val,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.defectiveGroupMemberOption = res.data.data.member;
          }
        });
    },
    handleCityChange(val) {
      this.$http
        .post("/erp/Defective/getCityGroups", {
          city: val,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.form.dgid = "0";
            this.form.dg_member_id = "0";
            this.defectiveGroupOption = res.data.data.group;
            this.defectiveGroupMemberOption = [];
          }
        });
    },
    addCat() {
      this.category.forEach((cat, index) => {
        if (cat.key == this.form.cat3) {
          if (this.cats.indexOf(cat.label) >= 0) {
            return false;
          }
          this.cats.push(cat.label);
          this.form.category.push(cat);
        }
      });
    },
    setCatChild(value) {
      this.second_category = [];
      for (const key in this.category) {
        if (value == this.category[key].key) {
          this.category.forEach((cat, index) => {
            if (cat.parent_id == value) {
              this.second_category.push(cat);
            }
          });
        }
      }
    },
    setCatChild1(value) {
      this.third_category = [];
      for (const key in this.category) {
        if (value == this.category[key].key) {
          this.category.forEach((cat, index) => {
            if (cat.parent_id == value) {
              this.third_category.push(cat);
            }
          });
        }
      }
    },
    setDefaultPayee(payee) {
      this.$confirm("确定设置此账号为默认收款账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showClose: false,
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/Supply/setDefaultPayee", {
              payee_id: payee.payee_id,
              supply_id: this.$route.params.id,
            })
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return false;
              }
              this.$message.success(res.data.msg);
            });
        })
        .catch(() => {
          return false;
        });
    },
    setBenchmarking() {
      if (
        this.form.is_benchmarking == 1 &&
        (this.form.is_all_style == 0 ||
          this.form.is_self == 0 ||
          this.form.baobmobile == "" ||
          this.form.supply_picker_group_member_id == 0)
      ) {
        this.$confirm(
          "商家未绑定爆版|未开通自主上款|上款类型为非全类目上款|未绑定买手",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            showClose: false,
            type: "warning",
          }
        )
          .then(() => {
            this.form.is_benchmarking = "0";
            return false;
          })
          .catch(() => {
            this.form.is_benchmarking = "0";
            return false;
          });
      }
      if (this.form.is_benchmarking == 0 && this.form.is_self_need_audit == 0) {
        this.$confirm("同时修改自主上款需要审核为 需要审核", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.is_self_need_audit = "1";
            return false;
          })
          .catch(() => {
            this.form.is_self_need_audit = "1";
            return false;
          });
      }
    },
    setOpenDeposit() {
      if (this.form.open_deposit == 1 && this.form.shopId == 0) {
        this.$confirm("邀请商家自主申请入驻需要绑定爆版店铺", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (
        this.form.open_deposit == 1 &&
        this.form.supply_picker_group_member_id == 0
      ) {
        this.$confirm("邀请商家自主申请入驻需要绑定买手", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (this.form.open_deposit == 1 && this.form.is_self == 0) {
        this.$confirm("邀请商家自主申请入驻需要开通自主上款权限", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (this.form.open_deposit == 1 && this.form.is_all_style == 0) {
        this.$confirm(
          "邀请商家自主申请入驻需要开通自主上款全类目权限",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            showClose: false,
            type: "warning",
          }
        )
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
    },
    setSelfNeedAudit() {
      if (this.form.is_self_need_audit == 0 && this.form.is_benchmarking == 0) {
        this.$confirm("只有履约率标杆商家可以选择为 不需要审核", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.is_self_need_audit = "1";
            return false;
          })
          .catch(() => {
            this.form.is_self_need_audit = "1";
            return false;
          });
      }
    },
    updatePayee(payee) {
      this.loading = true;
      if (payee) {
        this.spayee = payee;
        this.setCnap();
      } else {
        this.spayee = {
          payee_id: 0,
          payee_name: "",
          payee_bank: "",
          payee_bank_account: "",
          cnap: "",
        };
      }
      this.savePayeeVisible = true;
      this.loading = false;
    },
    savePayee() {
      this.spayee.supply_id = this.$route.params.id;
      this.$http.post("/erp/supply/savePayee", this.spayee).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          if (this.spayee.payee_id == 0) {
            this.form.payees.push({
              key: Date.now(),
              payee_id: res.data.data.payee.payee_id,
              payee_name: res.data.data.payee.payee_name,
              payee_bank: res.data.data.payee.payee_bank,
              payee_bank_account: res.data.data.payee.payee_bank_account,
              cnap_name: res.data.data.payee.cnap_name,
            });
          }

          this.$message.success(res.data.msg);
          this.savePayeeVisible = false;
        }
      });
    },
    setCnap(v) {
      if (v && v.length >= 2) {
        this.$http
          .post("/erp/common/getCnap", {
            bank: this.spayee.payee_bank,
            cnap_name: v,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.cnaps = res.data.data;
            }
          });
      } else {
        this.$http
          .post("/erp/common/getCnap", {
            bank: this.spayee.payee_bank,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.cnaps = res.data.data;
            }
          });
      }
    },
    showWxBox() {
      const { supply_id } = this.form;
      this.show_wx_add = true;
      this.$http
        .post("/erp/Supply/getSupplyWxNickname", {
          supply_id,
        })
        .then((res) => {
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          this.temp_arr = res.data.data;
          this.wx_nickname_arr = res.data.data;
          const arr = [];
          this.wx_nickname_arr.forEach(function (v, k) {
            arr.push(v.name);
          });
          this.resData.wx_nickname = arr.join(",");
        });
    },
    handleClose() {
      this.show_wx_add = false;
      this.wx_nickname_arr = this.this.temp_arr;
    },
    addNickname() {
      this.wx_nickname_arr.push({ id: 0, name: "", status: 0 });
    },
    changeWxStatus(index) {
      if (this.wx_nickname_arr[index].status == 1) {
        this.wx_nickname_arr[index].status = 0;
      } else {
        this.wx_nickname_arr[index].status = 1;
      }
    },
    addData() {
      this.loading = true;
      this.show_wx_add = false;
      if (this.wx_nickname_arr.length <= 0) {
        return this.$message.error("无可添加的数据");
      }
      this.$http
        .post("/erp/Supply/updateSupplyWxNickname", {
          data: this.wx_nickname_arr,
          supply_id: this.form.supply_id,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          this.$message.success("操作成功");
          this.temp_arr = res.data.data;
          this.wx_nickname_arr = res.data.data;
        });
    },
    setChild(value) {
      for (const key in this.market) {
        if (value == this.market[key].key) {
          this.child_market = this.market[key].children;
        }
      }
    },
    handleClose2(tag) {
      this.cats.splice(this.cats.indexOf(tag), 1);
      this.form.category.splice(this.form.category.indexOf(tag), 1);
    },
    fetchData(showLoading) {
      if (this.$route.params.id) {
        this.$http
          .get(
            `${this.url}/supply_id/${this.$route.params.id}`,
            this.filteredForm
          )
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.resData = res.data.data;
              this.market = this.resData.market;
              this.child_market = this.resData.child_market;
              this.floor = this.resData.floor;
              this.supply_area_list = this.resData.supply_area;
              this.pg_list = this.resData.pg_list;
              this.pickers = this.resData.pickers;
              this.supply_developer = this.resData.supply_developer;
              this.age_group_list = this.resData.age_group;
              this.category = this.resData.category;
              this.defectiveGroupMemberOption =
                this.resData.defectiveGroupMemberOption;
              this.defectiveGroupOption = this.resData.defectiveGroupOption;
              this.memberOption = this.resData.member_option;
              // this.options = this.resData.options;
              this.$set(this, "options", this.resData.options);

              this.PickerGroupMemberOption =
                this.resData.picker_group_member_option;
              if (res.data.data.supply.baobmobile) {
                this.$http
                  .post("/erp/supply/getBaobShopList", {
                    baobmobile: res.data.data.supply.baobmobile,
                    supply_id: res.data.data.supply.supply_id,
                  })
                  .then((res) => {
                    this.shop_list = res.data.data.shop_list;
                    this.data_date = res.data.data.data_date;
                  });
              }
              // 开发人重置为空字符串 不然下拉选择会很奇怪
              if (res.data.data.supply.supply_developer_admin == 0) {
                res.data.data.supply.supply_developer_admin = "";
              }
              // 这段拿来做判断
              this.current_developer =
                res.data.data.supply.supply_developer_admin;
              this.form = res.data.data.supply;
              // 直播频率默认值
              if (this.form.is_live == "0" && this.form.live_type == "0") {
                this.form.live_type = "1";
              }
              this.initShopId = this.form.shopId;
              this.form.is_show_brand =
                res.data.data.supply.is_show_brand.toString();
              const img = this.form.pic_url;
              const img2 = this.form.license_url;
              const img3 = this.form.avatar_url;
              const img4 = this.form.picture_url;
              this.pic = res.data.data.supply.pic;
              this.license = res.data.data.supply.license;
              this.avatar = res.data.data.supply.avatar;
              this.form.cat_ids = res.data.data.cats;
              this.picture = res.data.data.picture;
              this.baobmobile = res.data.data.supply.baobmobile;
              if (this.pic != "") {
                if (this.images1.indexOf(img) < 0) {
                  this.images1.push(img);
                }
              }
              if (this.license != "") {
                if (this.images2.indexOf(img2) < 0) {
                  this.images2.push(img2);
                }
              }
              if (this.avatar != "") {
                if (this.images3.indexOf(img3) < 0) {
                  this.images3.push(img3);
                }
              }
              this.images4 = img4;
              this.advantage = res.data.data.supply.advantage_placeholder;
              this.disadvantage = res.data.data.supply.disadvantage_placeholder;
              this.banks = res.data.data.banks;
              this.build_styles();
              this.build_second_styles();
            }
          });
      }
      this.supplySettleDays = supplySettleDays;
      this.isSignedContractSupply = isSignedContractSupply;
    },
    onSubmit() {
      this.loading = true;
      this.form.activeName = this.activeName;
      if (
        this.form.open_deposit == 1 &&
        this.form.supply_picker_group_member_id == 0
      ) {
        this.$confirm("开通邀约一定要绑定买手", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        });
        return false;
      }
      if (this.initShopId != this.form.shopId) {
        let initShopName = "";
        let nowShopName = "";
        for (const key in this.shop_list) {
          if (this.initShopId == this.shop_list[key].shopId) {
            initShopName = this.shop_list[key].shopName;
          }
          if (this.form.shopId == this.shop_list[key].shopId) {
            nowShopName = this.shop_list[key].shopName;
          }
        }
        let msg = `绑定店铺从${initShopName}变成${nowShopName},数据及一手权限功能将同步至${nowShopName}`;
        if (!initShopName) {
          msg = `绑定店铺${nowShopName}店，数据将会同步至${nowShopName}店！`;
        }
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.submitForm();
          })
          .catch(() => {
            return false;
          });
      } else {
        this.submitForm();
      }
    },
    submitForm() {
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message({
            type: res.data.data.msg_type,
            message: res.data.data.msg,
          });
          // 修改后重新获取数据
          this.$http
            .get("/erp/Supply/getAllSupplierNum", this.filteredForm)
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.restaurants = res.data.data;
              }
            });
          // 关闭当前编辑页, 返回列表页
          this.fetchData(true);
          const current_path =
            this.$parent.$parent.$parent.$parent.filterUriPrefix(
              this.$route.path
            );
          this.$parent.$parent.$parent.$parent.removeTab(current_path);
          this.$router.push("/home/supply/supplyList");
        }
      });
    },
    removePayee(item) {
      if (item.payee_id > 0) {
        this.$http
          .post("/erp/Supply/removePayee", {
            payee_id: item.payee_id,
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
              return false;
            }
          });
      }
      const index = this.form.payees.indexOf(item);
      if (index !== -1) {
        this.form.payees.splice(index, 1);
      }
    },
    addPayee() {
      this.form.payees.push({
        key: Date.now(),
        payee_id: 0,
        payee_name: "",
        payee_bank: "",
        payee_bank_account: "",
      });
    },

    changeBrand(item) {
      if (item.status == 1) {
        this.$confirm("禁用后，该品牌下的所有商品将变为“断货”状态", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            if (item.brand_id > 0) {
              this.$http
                .post("/erp/Supply/changeBrand", {
                  brand_id: item.brand_id,
                  supply_id: this.$route.params.id,
                })
                .then((res) => {
                  this.loading = false;
                  if (res.data.code !== 200) {
                    this.$message.error(res.data.msg);
                    return false;
                  }
                  this.$message.success(res.data.msg);
                  this.fetchData(false);
                });
            }
          })
          .catch(() => {
            return false;
          });
      } else if (item.brand_id > 0) {
        this.$http
          .post("/erp/Supply/changeBrand", {
            brand_id: item.brand_id,
            supply_id: this.$route.params.id,
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
              return false;
            }
            this.$message.success(res.data.msg);
            this.fetchData(false);
          });
      }
    },
    addBrand() {
      this.form.brands.push({
        key: Date.now(),
        brand_id: 0,
        brand_name: "",
        status: 1,
      });
    },
    setBrand() {
      this.form.brand = "";
      for (const key in this.form.brands) {
        for (const key2 in this.form.brands) {
          if (key != key2) {
            if (
              this.form.brands[key].brand_name ==
              this.form.brands[key2].brand_name
            ) {
              this.$message.error("品牌名不能重复", "提示");
              return false;
            }
          }
        }
        if (this.form.brands[key].brand_name) {
          this.form.brand += `${this.form.brands[key].brand_name},`;
        }
      }
      this.genSupplyName();
      this.brandVisible = false;
    },
    // 查询
    querySearch(queryString, cb) {
      const { restaurants } = this;
      const results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(item) {},
    changeStatus(value) {
      // if(value==0){
      this.statusVisible = true;
      // }
    },
    genSupplyName() {
      for (const key in this.floor) {
        if (this.form.supply_floor == this.floor[key].value) {
          this.floor_name = this.floor[key].label;
        }
      }
      for (const key in this.supply_area_list) {
        if (
          this.form.supply_area_id == this.supply_area_list[key].supply_area_id
        ) {
          this.supply_area = this.supply_area_list[key].supply_area;
        }
      }

      this.brand_name = this.form.brands[this.form.is_main].brand_name;
      if (this.form.supply_area_id == 0) {
        this.form.supply_name = `${this.floor_name}-${this.form.supplier_num}-${this.brand_name}`;
      } else {
        this.form.supply_name = `${this.floor_name}-${this.supply_area}-${this.form.supplier_num}-${this.brand_name}`;
      }
    },
    // 图片
    getSizeArr(val) {
      for (const key in val.all_item) {
        if (val.co_val == key) {
          this.$set(val, "sizeval_ary", val.all_item[key]);
        }
      }
      // 清空已经上次选择的尺码
      this.$set(val, "si_val", "");
    },
    beforeAvatarUpload(file) {
      if (this.pic != "") {
        this.$message.warning("只能上传一张");
        return false;
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 2) {
        this.$message.error(
          `图片太大了,请缩小到2MB以内再上传,当前图片大小:${size}MB`
        );
        return false;
      }
    },
    beforeAvatarUpload2(file) {
      if (this.license != "") {
        this.$message.warning("只能上传一张");
        return false;
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 2) {
        this.$message.error(
          `图片太大了,请缩小到2MB以内再上传,当前图片大小:${size}MB`
        );
        return false;
      }
    },
    previewImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    deleteImg1(v) {
      if (this.images1.indexOf(v) >= 0) {
        this.images1.splice(this.images1.indexOf(v), 1);
        this.form.pic = "";
        this.pic = "";
      }
    },
    deleteImg2(v) {
      if (this.images2.indexOf(v) >= 0) {
        this.images2.splice(this.images2.indexOf(v), 1);
        this.form.license = "";
        this.license = "";
      }
    },

    beforeAvatarUpload3(file) {
      if (this.avatar != "") {
        this.$message.warning("只能上传一张");
        return false;
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 2) {
        this.$message.error(
          `图片太大了,请缩小到2MB以内再上传,当前图片大小:${size}MB`
        );
        return false;
      }
    },
    beforePictureUpload(file) {
      if (this.images4.length >= 5) {
        this.$message.warning("只能上传五张");
        return false;
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 2) {
        this.$message.error(
          `图片太大了,请缩小到2MB以内再上传,当前图片大小:${size}MB`
        );
        return false;
      }
    },
    deleteImg3(v) {
      if (this.images3.indexOf(v) >= 0) {
        this.images3.splice(this.images3.indexOf(v), 1);
        this.form.avatar = "";
        this.avatar = "";
      }
    },
    deleteImg4(v) {
      if (this.images4.indexOf(v) >= 0) {
        const index = this.images4.indexOf(v);
        this.images4.splice(index, 1);
        this.form.picture.splice(index, 1);
      }
    },
    uploadSuccess1(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;
        this.form.pic = res.data.files[0];
        this.pic = res.data.files[0];
        if (this.images1.indexOf(img) < 0) {
          this.images1.push(img);
        }
      }
    },
    uploadSuccess2(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;
        this.form.license = res.data.files[0];
        if (this.images2.indexOf(img) < 0) {
          this.images2.push(img);
        }
      }
    },
    uploadSuccess4(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const picture = `${this.origin}/${res.data.files[0]}`;
        if (this.images4.indexOf(picture) < 0) {
          this.images4.push(picture);
          this.form.picture.push(res.data.files[0]);
        }
      }
    },
    uploadSuccess3(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;

        const image = new Image();
        image.src = img;
        const z = this;
        image.onload = function () {
          const { width } = image;
          const { height } = image;
          if (width != height) {
            z.$message.error("必须上传正方形");
          } else if (
            width > 800 ||
            width < 130 ||
            height > 800 ||
            height < 130
          ) {
            z.$message.error("长宽必须在130px~800px之间");
          } else {
            z.form.avatar = res.data.files[0];
            if (z.images3.indexOf(img) < 0) {
              z.images3.push(img);
            }
          }
        };
      }
    },
    handleRemove(file, fileList) {},
    handleExceed(files, fileList) {
      if (this.pic != "") {
        this.$message.warning("只能上传一张");
      }
    },
    handleExceed2(files, fileList) {
      if (this.license != "") {
        this.$message.warning("只能上传一张");
      }
    },
    handleExceed3(files, fileList) {
      if (this.avatar != "") {
        this.$message.warning("只能上传一张");
      }
    },
    handleExceed4(files, fileList) {
      this.$message.warning("最多只能上传五张");
    },
    returnData(e) {
      this.form.is_signed_contract = e.is_signed_contract;
      this.form.settle_days = e.settle_days;
    },
    sycnWcgOrder() {
      this.$confirm("是否同步一手代采单至爆版店铺 ?", "同步提示", {
        closeOnClickModal: false,
      }).then((_) => {
        const { supply_id } = this.form;
        this.$http
          .post("/erp/Supply/syncWcgOrderToBaob", { supply_id })
          .then((rs) => {
            if (rs.data.code != 200) return this.$message.error(rs.data.msg);
            if (rs.data.data) this.form.wcg_order_sync_time = rs.data.data;
            return this.$message.success("同步成功");
          });
      });
    },
    build_second_styles() {
      this.second_styles_data = [];
      const { style } = this.resData;
      if (this.form.styles) {
        for (var i = 0, len = style.length; i < len; i++) {
          // 判断in_array
          const is = this.form.styles.some(function (v) {
            return style[i].key === v;
          });
          if (is) {
            this.second_styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
              disabled: true,
            });
          } else {
            this.second_styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
            });
          }
        }
      }
    },
    build_styles() {
      this.styles_data = [];
      const { style } = this.resData;
      if (this.form.second_styles) {
        for (var i = 0, len = style.length; i < len; i++) {
          // 判断in_array
          const is = this.form.second_styles.some(function (v) {
            return style[i].key === v;
          });
          if (is) {
            this.styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
              disabled: true,
            });
          } else {
            this.styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
            });
          }
        }
      }
    },

    // 获取商家可上款数
    getSupplyPutLimit() {
      this.$http
        .post("/erp/Supply/getSupplyPutLimit", {
          supply_id: this.$route.params.id,
        })
        .then((rs) => {
          // 没有获得
          if (rs.data.code != 200) {
            return;
          }
          // 显示分层的tag
          this.$set(this.setag, "show", true);
          this.$set(this.setag, "form", rs.data.data);
        });
    },

    // 提交商家分层
    submitSetag() {
      // console.log(this.setag.form);
      this.$set(this.setag.form, "supply_id", this.$route.params.id);
      this.$http
        .post("/erp/Supply/setSupplyPutLimit", this.setag.form)
        .then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.e(rs.data.msg);
          }
          this.$message.success("保存成功");
        });
      // 关闭当前编辑页, 返回列表页
      this.fetchData(true);
      const current_path = this.$parent.$parent.$parent.$parent.filterUriPrefix(
        this.$route.path
      );
      this.$parent.$parent.$parent.$parent.removeTab(current_path);
      this.$router.push("/home/supply/supplyList");
    },

    handleViewVideo(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/ShowSupply.vue